import styles from './../components/css/HomePage.module.css';


const ScrollThrough = (props) => {

  const text = '$PPGC GOLD V2 ';
  const repeatedText = text.repeat(9); // same number of repeats as spans

  return(
    <div className={`${styles.scrollThrough} `}>
      <div className={props.scrollType} data-text={repeatedText}>
        <p>{props.ScrollThrough}</p>
        <span className='me-3'>$PPGC GOLD V2</span>
        <span className="me-3">$PPGC GOLD V2</span>
        <span className='me-3'>$PPGC GOLD V2</span>
        <span className='me-3'>$PPGC GOLD V2</span>
        <span className='me-3'>$PPGC GOLD V2</span>
        <span className='me-3'>$PPGC GOLD V2</span>
        <span className='me-3'>$PPGC GOLD V2</span>
        <span className='me-3'>$PPGC GOLD V2</span>
        <span className='me-3'>$PPGC GOLD V2</span>
      </div>
    </div>
  )
}

export default ScrollThrough;